
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';

import Layout from 'components/Dashboard/Layout';
import { ListProvider, ListContext } from 'core/ListProvider';
import TableListFooter from 'core/TableListFooter';
import SearchWidget from 'form/SearchWidget';
import { YellowButton } from 'ui/Button';
import { ClientListTable } from './ListTable';
import { ResponsiveTable } from 'ui/Table';
import {AutocompleteMultipleWidget2} from "../../form/AutocompleteMultipleWidget2";
import { UserContext, hasAccountPermission } from 'components/User';
import { SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';



export default class ClientList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Клиенты';
  }

  onDetail = (item) => {
    this.props.history.push(`/client/${item.id}`);
  };

  render() {
    const canAdd = hasAccountPermission(this.context, 'client.add_client');

    return (
      <ListProvider
        url={'client'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, permissions } = context;

            const addButton = canAdd
              ? (
                <YellowButton component={Link} to={`/client/add`} startIcon={<AddIcon />}>
                  Добавить клиента
                </YellowButton>
              )
              : undefined;

            return (
              <Layout>

                <Layout.Header
                  title={'Клиенты'}
                  search={
                    <SearchWidget
                      value={context.filter.q}
                      onChange={(value) => context.setFilterValue('q', value)}
                    />
                  }
                  right={addButton}
                />

                <Layout.Filter>
                  <div style={{minWidth: 220, maxWidth: 400, flex: '1 1 220px'}}>
                    <AutocompleteMultipleWidget2
                      url={'account/staff'}
                      filter={{
                        current_department: true,
                        is_active: true
                      }}
                      optionLabel={'short_name'}
                      value={context.filter.personal_manager}
                      onChange={(options, optionsId) => context.setFilterValue('personal_manager', optionsId)}
                      size={'small'}
                      label={'Менеджер'}
                    />
                  </div>
                  <SelectButtonGroupWidget
                    value={context.filter.is_active}
                    options={[
                      {value: null, label: 'Все'},
                      {value: true, label: 'Активные'},
                      {value: false, label: 'Неактивные'},
                    ]}
                    onChange={(value) => context.setFilterValue('is_active', value)}
                  />
                </Layout.Filter>

                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <ClientListTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                        hasChangePermission={permissions.change}
                      />
                      <TableListFooter colspan={6} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>

              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
